import { useMemo } from "react";

export function useReadingTime(content) {
  return useMemo(() => {
    if (!content) return 0;

    const WORDS_PER_MINUTE = 225;
    const MINIMUM_READ_TIME = 1;

    const cleanText = content.replace(/<[^>]*>/g, "").trim();
    const wordCount = cleanText.split(/\s+/).length;

    return Math.max(Math.ceil(wordCount / WORDS_PER_MINUTE), MINIMUM_READ_TIME);
  }, [content]);
}
